import { EndiciaRedirect } from './EndiciaRedirect.component';

export default { EndiciaRedirect };
